import { TrackingRouteService } from 'common/data';
import { BaseService } from 'core/services';

class TrackingService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new TrackingRouteService());
	}

	track = body => {
		const url = this.routeService.track();
		return this.apiClient.post(url, body);
	};
}

export default TrackingService;



// WEBPACK FOOTER //
// ./src/common/data/services/TrackingService.js